const NBSP = '\u00A0';

export function isEnglishLocale(language: string): boolean {
  return language.toLowerCase().startsWith('en');
}

export function formatDashboardMoney(cents: number, language: string): string {
  const amount = cents / 100;
  const hasDecimals = Math.round(Math.abs(cents)) % 100 !== 0;
  const digits = {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: hasDecimals ? 2 : 0,
  };
  if (isEnglishLocale(language)) {
    return `DKK${NBSP}${amount.toLocaleString('en-GB', digits)}`;
  }
  return `${amount.toLocaleString('da-DK', digits)}${NBSP}kr.`;
}

export function formatDashboardTime(value: string | Date, language: string): string {
  const date = value instanceof Date ? value : new Date(value);
  const hh = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');
  return isEnglishLocale(language) ? `${hh}:${mm}` : `${hh}.${mm}`;
}

export function formatDashboardTimeRange(
  start: string | Date,
  end: string | Date,
  language: string,
): string {
  return `${formatDashboardTime(start, language)}–${formatDashboardTime(end, language)}`;
}

export function formatDashboardGreetingDate(date: Date, language: string): string {
  if (isEnglishLocale(language)) {
    return date
      .toLocaleDateString('en-GB', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
      .replace(',', '');
  }
  const raw = date
    .toLocaleDateString('da-DK', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })
    .replace(/\s+den\s+/i, ' ');
  return raw.replace(/^./, (char) => char.toUpperCase());
}

export function formatDashboardMessageTime(iso: string, now: Date, language: string): string {
  const date = new Date(iso);
  if (date.toDateString() === now.toDateString()) {
    return formatDashboardTime(date, language);
  }
  if (isEnglishLocale(language)) {
    const day = date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    return `${day}, ${formatDashboardTime(date, language)}`;
  }
  const day = date.toLocaleDateString('da-DK', { day: 'numeric', month: 'short' });
  return `${day}, kl. ${formatDashboardTime(date, language)}`;
}

export function appointmentIsCurrent(
  start: string,
  end: string,
  now: Date,
  cancelled: boolean,
): boolean {
  if (cancelled) return false;
  const startMs = new Date(start).getTime();
  const endMs = new Date(end).getTime();
  const nowMs = now.getTime();
  return Number.isFinite(startMs) && Number.isFinite(endMs) && nowMs >= startMs && nowMs < endMs;
}
